import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconRubRound.tsx
const IconRubRound = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "M16 2.665c7.365 0 13.335 5.97 13.335 13.335S23.365 29.335 16 29.335 2.665 23.365 2.665 16 8.635 2.665 16 2.665m-2.844 7.187v5.966h-1.848v1.873h1.848v.933h-1.848v1.871h1.848v1.928h2.271v-1.928h2.757v-1.871h-2.757v-.933h2.468q1.442 0 2.456-.491 1.012-.498 1.547-1.37.533-.878.534-2.032 0-1.11-.528-2-.522-.897-1.535-1.418-1.013-.528-2.474-.528zm4.74 1.89q.766 0 1.263.276.503.27.749.743.252.467.246 1.056.006.6-.246 1.05a1.67 1.67 0 0 1-.76.699q-.51.252-1.302.252h-2.419v-4.076z"
	})]
});
var IconRubRound_default = forwardRef(IconRubRound);
//#endregion
export { IconRubRound_default as default };
